import React, { lazy } from 'react';
import { CheckIcon } from 'lucide-react';
export function OfferSection() {
  return <section className="py-12 px-4 bg-dark-100" data-id="element-176">
      <div className="max-w-5xl mx-auto" data-id="element-177">
        <p className="text-[13px] uppercase tracking-[0.1em] text-gold text-center mb-3" data-id="element-178">
          La Oferta
        </p>
        <div className="text-center mb-12" data-id="element-179">
          <h2 className="text-2xl md:text-3xl font-bold text-body mb-2" data-id="element-180">
            THE RESET PROTOCOL: Recalibración Mental en 30 Días.
          </h2>
          <p className="text-base text-gold font-serif italic" data-id="element-181">
            Lo que recibirás hoy:
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-182">
          {/* Product Mockup */}
          <div className="w-full md:w-1/2 flex justify-center" data-id="element-183">
            <img src="https://cdn.magicpatterns.com/uploads/eUMaxiDeNTeponHVZGA7Xu/hf_20260323_013626_57688643-b6e0-4981-ab06-2be0772525cd.jpg" alt="The Reset Protocol Mockup" className="w-full max-w-md h-auto rounded-lg" loading="lazy" decoding="async" data-id="element-184" />
          </div>

          {/* Offer Items */}
          <div className="w-full md:w-1/2 space-y-[8px]" data-id="element-185">
            <div className="flex items-start gap-3" data-id="element-186">
              <CheckIcon className="w-[18px] h-[18px] text-gold shrink-0 mt-0.5" data-id="element-187" />
              <div className="text-base" data-id="element-188">
                <span className="text-body font-bold" data-id="element-189">
                  PROTOCOLO DE RECALIBRACIÓN MENTAL:
                </span>{' '}
                <span className="text-sub" data-id="element-190">
                  El manifiesto de Gabriel para entender tu nueva frecuencia.
                </span>
              </div>
            </div>

            <div className="flex items-start gap-3" data-id="element-191">
              <CheckIcon className="w-[18px] h-[18px] text-gold shrink-0 mt-0.5" data-id="element-192" />
              <div className="text-base" data-id="element-193">
                <span className="text-body font-bold" data-id="element-194">
                  HOJA DE RUTA: TU PLAN DE 30 DÍAS:
                </span>{' '}
                <span className="text-sub" data-id="element-195">
                  Tu plan paso a paso. Sin adivinanzas.
                </span>
              </div>
            </div>

            <div className="flex items-start gap-3" data-id="element-196">
              <CheckIcon className="w-[18px] h-[18px] text-gold shrink-0 mt-0.5" data-id="element-197" />
              <div className="text-base" data-id="element-198">
                <span className="text-body font-bold" data-id="element-199">Librería de Audios:</span>{' '}
                <span className="text-sub" data-id="element-200">
                  Frecuencias 6AM, Enfoque y Recalibración Profunda
                  (Delta/Theta).
                </span>
              </div>
            </div>

            <div className="flex items-start gap-3" data-id="element-201">
              <CheckIcon className="w-[18px] h-[18px] text-gold shrink-0 mt-0.5" data-id="element-202" />
              <div className="text-base" data-id="element-203">
                <span className="text-body font-bold" data-id="element-204">
                  Comunidad Privada en Telegram:
                </span>{' '}
                <span className="text-sub" data-id="element-205">No camines solo.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}